<template>
  <div>
    <SupportChatButton
      v-if="!isOpen"
      :toggleChat="toggleChat"
      :hasUnreadMessages="hasUnreadMessages"
    />

    <SupportChatWindow
      v-if="isOpen"
      :isOpen="isOpen"
      :toggleChat="toggleChat"
      :threadId="supportThreadId"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import SupportChatButton from './ui/SupportChatButton.vue'
import SupportChatWindow from './ui/SupportChatWindow.vue'
import { useSupportChat } from './model'

const { isOpen, supportThreadId, toggleChat } = useSupportChat()

const hasUnreadMessages = computed(() => false)
</script>
